import { useAppSelector } from 'shared';

export const useOutdoorBarArticlePageState = () => useAppSelector(
    (store) => store.outdoorBarArticlePage,
);
